import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Form, FormGroup } from 'reactstrap';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';

export const BAGGAGE_QR_FORM = 'BaggageQRModalForm';

const BaggageQRModalForm = ({ handleSubmit }) => {
  useEffect(() => {
    const input = document.querySelector('.qr-series-correlative');
    if (input) input.focus();
  }, []);

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Serie - Correlativo" required>
          <Field
            name="serieCorrelative"
            component={TextInput}
            type="text"
            placeholder="Escanear QR..."
            className="form-control qr-series-correlative"
          />
        </FormItem>
      </FormGroup>
    </Form>
  );
};

BaggageQRModalForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: BAGGAGE_QR_FORM,
})(BaggageQRModalForm);